import { mapGetters, mapState } from 'vuex';
import plantsClient from '@/core/services/plants';
import { Vue, Options } from 'vue-class-component';
import {
  EPDeviceDTO,
  EntrancePlantDetailDTO,
  GateDTO,
} from '@/../client-generator/generated-clients/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import DeviceObjectGroup from './DeviceObjectGroup/DeviceObjectGroup.vue';
import DialogConfigureGate from './DialogConfigureGate/DialogConfigureGate.vue';
import DialogConfirmDeleteGate from './DialogConfirmDeleteGate/DialogConfirmDeleteGate.vue';
import { getDeviceIconFromType } from '../../../../core/utils/EntrancePlant/entrance-plant.utils';
import DialogWarning from './DialogWarning/DialogWarning.vue';
import DialogRenameGate from '../EntrancePlantSettings/EntrancePlantStructure/DialogRenameGate/DialogRenameGate.vue';

@Options({
  name: 'EntrancePlantGate',
  emits: ['add-object', 'add-structure', 'update-list'],
  components: {
    DeviceObjectGroup,
    DialogConfigureGate,
    DialogConfirmDeleteGate,
    DialogWarning,
    DialogRenameGate,
  },
  computed: {
    ...mapState(['currentEntrancePlant', 'adminView']),
    ...mapGetters('UI', ['gateEditEnabled', 'gateDeleteEnabled']),
  },
})
export default class EntrancePlantGate extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  adminView!: boolean;
  isVisibleDeleteGateConfirm = false;
  isVisibleDialogAssignObject = false;
  isVisibleDialogConfigureGate = false;
  isVisibleDeleteGateWithDevicesWarning = false;
  getGateIconFromType = getDeviceIconFromType;

  gateEditEnabled!: boolean;
  gateDeleteEnabled!: boolean;
  isVisibleRenameGateDialog: boolean = false;

  get gateDevices() {
    if (this.currentGate && this.hasDevices) {
      const devices = (this.currentGate.devices ?? []).sort(
        (a, b) => a.type! - b.type!
      );
      return devices;
    }

    return [];
  }

  get hasDevices() {
    return !!this.currentGate?.devices?.length;
  }

  get currentGate(): GateDTO | null {
    return (
      this.currentEntrancePlant?.gates?.find(
        (x) => x.gateId?.toString() === this.$route.params.gateId
      ) ?? null
    );
  }

  get gateId() {
    return this.$route.params.gateId as string;
  }

  get backLink() {
    return {
      name: 'page-entranceplant-dashboard',
      params: this.$route.params,
    };
  }

  get countConfigurationToEnd() {
    return this.gateDevices.filter((k: EPDeviceDTO) => !k.isConfigured).length;
  }

  mounted() {
    if (this.$route.query.refresh) {
      this.$emit('update-list');
      this.$router.push({
        name: 'page-entranceplant-gate',
        params: this.$route.params,
      });
    }
  }

  async toggleAddGateDeviceDialog() {
    alert('TODO');
  }

  async toggleConfigureGateDialog() {
    if (this.isVisibleDialogConfigureGate) {
      this.isVisibleDialogConfigureGate = false;
      this.$store.dispatch(SET_APP_LOADING, false);
    } else {
      this.$store.dispatch(SET_APP_LOADING, true);
      this.isVisibleDialogConfigureGate = true;
    }
  }

  showRenameGateDialog() {
    this.isVisibleRenameGateDialog = true;
  }

  toggleDeleteGateConfirm() {
    if (!this.isVisibleDeleteGateConfirm && this.hasDevices) {
      this.isVisibleDeleteGateWithDevicesWarning = true;
    } else {
      this.isVisibleDeleteGateConfirm = !this.isVisibleDeleteGateConfirm;
    }
  }

  toggleDeleteGateWithDevicesWarning() {
    this.isVisibleDeleteGateWithDevicesWarning = !this
      .isVisibleDeleteGateWithDevicesWarning;
  }

  handeCancelClick() {
    this.isVisibleDeleteGateConfirm = false;
  }

  async deleteGate() {
    if (
      !this.currentEntrancePlant ||
      !this.currentEntrancePlant.desktopId ||
      !this.currentGate ||
      !this.currentGate.gateId
    )
      return;
    try {
      this.$store.dispatch(SET_APP_LOADING, true);
      await plantsClient.gateDELETE(
        this.currentEntrancePlant.desktopId,
        this.currentGate.gateId
      );

      this.$store.dispatch(SET_APP_LOADING, false);
      this.$emit('update-list');
      this.$toast.add({
        severity: 'success',
        summary: this.$t('entrancePlant.gateDeletedSuccess'),
        closable: false,
        life: 3000,
      });
      this.$router.push({ name: 'page-entranceplant-dashboard' });
    } catch (error) {
      switch (error.status) {
        case 423:
          this.$router.push({
            name: 'page-plants-hub',
          });
          break;
      }
      console.log(error);
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  async handleDeleteDevice(object: EPDeviceDTO) {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      await plantsClient.deleteRoomObject(
        this.currentEntrancePlant.desktopId as number,
        this.gateId,
        object.deviceId ?? ''
      );
      this.$emit('update-list');
      this.$router.push({
        name: 'page-entranceplant-gate',
        params: this.$route.params,
      });
    } catch (error) {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 3000,
      });
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  hideRenameGateDialog() {
    this.isVisibleRenameGateDialog = false;
  }

  handleUpdateList() {
    this.$emit('update-list');
  }
}
